<template>
<v-app id="inspire">
  <v-content class="teal darken-3">
    <div style="text-align: -webkit-center" class="teal darken-3">
      <v-card class="mt-5" width="50%">
        <v-card-title>
          Check In Customer
        </v-card-title>
        <v-card-text>
          <v-text-field hint="Tekan Enter untuk mencari customer" persistent-hint v-model="inputSearch" @keyup.enter="searchUser" label="Masukkan Email / Telp Customer"></v-text-field>
          <template v-if="userFound">
            <v-card width="100%" outlined color="green darken-1" dark class="white--text mt-5">
              <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 caption font-weight-bold">Data User Ditemukan</span>
              <v-divider></v-divider>
              <p class="mx-2 mb-0 caption">Nama: {{ dataNewCustomer.name }}</p>
              <p class="mx-2 mb-0 caption">Email: {{ dataNewCustomer.email }}</p>
              <p class="mx-2 mb-0 caption">Phone: {{ dataNewCustomer.telp }}</p>
            </v-card>
          </template>
          <template v-else>
            <v-card width="100%" outlined color="orange darken-1" dark class="white--text mt-5 mb-5">
              <v-icon class="ma-1">info</v-icon><span style="vertical-align: text-top" class="ma-2 caption">Data user tidak ditemukan</span>
              <v-divider></v-divider>
              <p class="ma-2 caption">Maaf, email atau nomor telepon user tidak ditemukan.</p>
            </v-card>
            <a href="/registrasi" target="_blank" class="text-decoration-underline">Belum punya akun?</a>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="[userFound = false, inputSearch = null]">Clear</v-btn>
          <!-- <v-btn v-if="userFound" color="blue darken-1" text @click="[dataCustomer = dataNewCustomer, dialogPilihCustomer = false, createPesanan(), dataNewCustomer = {}]">Check In</v-btn> -->
        </v-card-actions>
      </v-card>
        <!-- <v-card class="mt-2" width="50%">
            <v-card-title class="teal darken-4 white--text">Form Registrasi Customer</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-form @submit="validate" ref="form" v-model="valid" lazy-validation>
                  <v-text-field v-model="inputDataCustomer.name" :rules="[ v => !!v || 'Required.']" label="Name"></v-text-field>
                  <v-text-field v-model="inputDataCustomer.username" :rules="[ v => !!v || 'Required.']" label="Username"></v-text-field>
                  <v-autocomplete
                    v-model="inputDataCustomer.role_id"
                    :items="roles"
                    :rules="[ v => !!v || 'Required.']"
                    item-text='name'
                    item-value='id'
                    label="Tipe User"
                  ></v-autocomplete>
                  <v-text-field 
                    v-model="inputDataCustomer.email"
                    :rules="[ v => !!v || 'Required.']"
                    label="Email">
                  </v-text-field>
                  <v-text-field type="number" v-model="inputDataCustomer.telp" label="Telp" :rules="[ v => !!v || 'Required.']"></v-text-field>
                  <v-text-field type="password" v-model="inputDataCustomer.password" label="Password" :rules="[ v => !!v || 'Required.']"></v-text-field>
                  <v-text-field type="password" v-model="inputDataCustomer.password_conf" label="Confirmation" :rules="[ v => !!v || 'Required.']"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn 
                  class="teal darken-4 white--text"
                  :disabled="!valid"
                  medium
                  @click="validate"
              >
                  Daftar
              </v-btn>
          </v-card-actions>
        </v-card> -->
        <p class="display-1 font-weight-light ma-5 white--text">Jadwal Hari Ini</p>
        <template>
            <div class="ma-5">
                <v-data-table
                    :headers="headers"
                    :items="listCheckIn"
                    show-expand
                    :single-expand="true"
                    class="elevation-1"
                    color="green lighten-1"
                >
                  <template v-slot:[`item.no`]="{ item }">
                    {{(listCheckIn.indexOf(item)+1) + '.'}}
                  </template>
                  <template v-slot:[`item.checkIn`]="{ item }">
                    <template v-if="!userFound">
                      {{ getAttendance(item.checkIn) }}
                    </template>
                    <template v-else>
                      {{ getAttendance(item.checkIn) }}
                      <v-btn
                        color="success"
                        fab
                        x-small
                        dark
                        @click="addCheckIn(item)"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                  </template>
                  <template v-slot:[`expanded-item`]="{ headers, item }">
                    <td :colspan="headers.length" class="px-6 pt-2 pb-6">
                      <div class="text-center pa-2"><span class="title">Daftar Hadir</span></div>
                      <template v-if="item.checkIn.length > 0">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead class="grey grey lighten-2">
                              <tr>
                                <th class="text-left">
                                  No.
                                </th>
                                <th class="text-left">
                                  Nama
                                </th>
                                <th class="text-left">
                                  Telepon
                                </th>
                                <th class="text-left">
                                  Jam Masuk
                                </th>
                                <th class="text-left">
                                  Jam Keluar
                                </th>
                                <th class="text-left">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(data, index) in item.checkIn"
                                :key="data.id+'-'+index"
                                >
                                <td>{{index+1}}.</td>
                                <td>{{ data.name }}</td>
                                <td>{{ data.telp }}</td>
                                <td>{{ data.checkInTime }}</td>
                                <td>{{ data.checkOutTime }}</td>
                                <td>                                
                                    <v-btn
                                        v-if="data.checkOutTime == '-'"
                                        x-small
                                        fab
                                        color="red"
                                        outlined
                                        @click="checkOut(item, index)"
                                    >
                                      <v-icon>logout</v-icon>
                                    </v-btn>
                                    <span v-else>-</span>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </template>
                      <template v-else><div class="text-center"><span>No data available.</span></div></template>
                    </td>
                  </template>
                </v-data-table>
            </div>
        </template>
    </div>
  </v-content>
  <v-snackbar style="z-index: 9999"
    :top='true'
    v-model='snackbar.visible'
    :color='snackbar.color'
    :timeout='snackbar.timeout'
    :multi-line='snackbar.multiline'
  >{{snackbar.text}}</v-snackbar>
</v-app>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, isEmpty, remove, find, uniqBy } from "lodash";
import moment from 'moment';
import firebase from "../firebaseConfig.js";
const db = firebase.database();
export default {
  name: "CheckIn",
  components: {
  },
  data() {
    return {
      valid: true,
      inputSearch: null,
      userFound: false,
      dataNewCustomer: {},
      listCheckIn: [],
      headers: [
          {
            text: 'No.',
            align: 'start',
            value: 'no',
            class: 'white--text'
          },
          {text: 'Submission Name',value: 'item.submission.name',class: 'white--text'},
          {text: 'Customer Name',value: 'item.submission.customer.name',class: 'white--text'},
          {
            text: 'Services',
            align: 'start',
            value: 'item.item_name',
            class: 'white--text'
          },
          {text: 'Start',value: 'start',class: 'white--text'},
          {text: 'Finish',value: 'finish',class: 'white--text'},
          {text: 'Customer Check In',value: 'checkIn',class: 'white--text',align: 'center'},
          {text: '', value: 'data-table-expand' }
      ],
      headerSubItems: [
          {
            text: 'No.',
            align: 'start',
            value: 'no',
            class: 'white--text'
          },
          {text: 'Nama',value: 'nama',class: 'white--text'},
          {text: 'Telepon',value: 'telepon',class: 'white--text'},
          {text: 'Masuk',value: 'masuk',class: 'white--text'},
      ],
    };
  },
  computed: {
      ...mapGetters({
      }),
      ...mapState({
          snackbar: state => state.snackbar,
      })
  },
  mounted() {
    this.initialize()
  },

  methods: {
    ...mapMutations({
      showSnackbar: "showSnackbar",
      closeLoading: "closeLoading",
    }),
    ...mapActions({
      createUser: "user/createUser",
      cekJadwal: "jadwal/cekJadwal",
      getUsersByEmailOrPhone: "user/getUsersByEmailOrPhone",
    }),
    getAttendance(items){
        // console.log('item', items)
        let tempItem = []
        forEach(items, item => {
          if(item.checkOutTime === '-'){
            tempItem.push(item)
          }
        })

        tempItem = uniqBy(tempItem, 'id')
        return tempItem.length;
    },
    async initialize(){
      const companyId = JSON.parse(window.localStorage.getItem('company')).id
      let now = moment().format('YYYY-MM-DD')
      let attendanceRefs = db.ref('Attendance-'+companyId+'-'+process.env.VUE_APP_ENV)
      attendanceRefs.child(now).once('value', (snap) => {
        if(snap.val() == null){
          db.ref("Attendance-"+companyId+'-'+process.env.VUE_APP_ENV)
            .child(now).set(this.listCheckIn)
            .then(() => {
              console.log("Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        }
      });

      attendanceRefs.child(now).on('value', (snap) => {
        if(snap.val()){
          this.listCheckIn = snap.val()
          this.listCheckIn.forEach(list => {
            if(!list.checkIn){
              list.checkIn = []
            }
          })
        }
      });
    },
    async searchUser(){
      if(this.inputSearch != '' && this.inputSearch != null){
          this.userFound = false
          const response = await this.getUsersByEmailOrPhone(this.inputSearch)

          if(response.data != ""){
              this.dataNewCustomer.id = response.data.id
              this.dataNewCustomer.name = response.data.name
              this.dataNewCustomer.email = response.data.email
              this.dataNewCustomer.telp = response.data.telp
              this.userFound = true
          }
      }
    },
    addCheckIn(item){
      const payload = {
        ...this.dataNewCustomer,
        checkInTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        checkOutTime: '-'
      }
      this.listCheckIn[this.listCheckIn.indexOf(item)].checkIn.push(payload)
      this.userFound = false
      this.inputSearch = null
      const companyId = JSON.parse(window.localStorage.getItem('company')).id

      db.ref("Attendance-"+companyId+'-'+process.env.VUE_APP_ENV)
        .child(moment().format('YYYY-MM-DD')).set(this.listCheckIn)
        .then(() => {
          console.log("Document successfully written!");
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },
    checkOut(item, index){
      const companyId = JSON.parse(window.localStorage.getItem('company')).id
      this.listCheckIn[this.listCheckIn.indexOf(item)].checkIn[index].checkOutTime = moment().format('YYYY-MM-DD HH:mm:ss')
      db.ref("Attendance-"+companyId+'-'+process.env.VUE_APP_ENV)
        .child(moment().format('YYYY-MM-DD')).set(this.listCheckIn)
        .then(() => {
          console.log("Document successfully written!");
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },
  }
};
</script>
<style>
@media print {
  body * {
    background: white!important;
  }
}
</style>